'use client';

import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';
import React, { useEffect } from 'react';
import { Header } from '@/components/layout/header';
export default function Error({
  error
}: {
  error: Error;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return <div data-sentry-component="Error" data-sentry-source-file="error.tsx">
      <Header shopNavigation data-sentry-element="Header" data-sentry-source-file="error.tsx" />
      <div className={'py-16 text-center'}>
        <h4 className={'text-h4 mb-4'}>Oops! Something went wrong.</h4>
        <p>
          Don’t worry – we’re on it! In the meantime, try refreshing the page or
          head back{' '}
          <Link className={'outline-offset-2 text-blue-600 hover:text-blue-500 underline'} href={'/'} data-sentry-element="Link" data-sentry-source-file="error.tsx">
            home
          </Link>{' '}
          .
        </p>
      </div>
    </div>;
}